import React, { useState, useRef, Suspense } from "react";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import InputComponent from "../components/input-component/input-component";
import CompilationErrorsBox from "../components/compilation-errors";
import useStyles from "../components/styles";
import Button from "../components/button";
import AutomaticTestingToolHeader from "./../components/automatic-testing-tool-header";
import Disclaimer from "../components/disclaimer";
import copyToClipboard from "copy-to-clipboard";
import store from "src/store";

export default function GetContractABI() {
  const title = 'Get contract ABI';
  const description = "This component enables users to upload their smart contract code via our user-friendly multi-file code editor. After compiling the code, provided there are no syntax errors, the component produces the Application Binary Interface (ABI) as an output. Users can conveniently copy the ABI to their clipboard with a simple button click, facilitating seamless integration of smart contracts into their projects."

  const { t } = useTranslation();
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [abi, setAbi] = useState(null);
  const [files, setFiles] = useState([]);
  const [compilerVersion, setCompilerVersion] = useState('');
  const [mainContract, setMainContract] = useState('');
  const [compilerSettings, setCompilerSettings] = useState('');
  const [mainFile, setMainFile] = useState('');
  const [selectedFilePath, setSelectedFilePath] = useState('');
  const [importPopoverAnchorEl, setImportPopoverAnchorEl] = useState(null);
  const [response, setResponse] = useState({ errors: [], test_results: [] });
  const [copyTip, setCopyTip] = useState("Copy to clipboard");

  async function submitCode() {
    try {
      setIsSubmitLoading(true);
      setAbi(null); // Clear the ABI section when scanning again
      if (!mainFile) {
        setMainFile("main.sol");
      }

      const { abi } = await store.getAbi({
        files,
        mainContract,
        mainFile: mainFile || "main.sol",
        compilerVersion,
        compilerSettings,
      });

      setAbi(abi);
      setResponse(response);
      setIsSubmitLoading(false);
    } catch (err) {
      setIsSubmitLoading(false);
    }
  }

  const handleCopy = () => {
    if (abi) {
      copyToClipboard(JSON.stringify(abi, null, 2));
      setCopyTip("Copied!");
      setTimeout(() => setCopyTip("Copy to clipboard"), 2000);
    }
  };

  const classes = useStyles({});

  return (
    <div
      css={`
        padding: 35px;
        background: #F6F6FA;
        min-height: 100vh;
      `}
    >
      <Suspense fallback={null}>
        <AutomaticTestingToolHeader title={title} description={description}></AutomaticTestingToolHeader>
        <Disclaimer />
        <hr css={`
          margin-top:15px;
          border: 1px solid #EAEAF2;
        `} />
        <div
          css={`
            margin-top:25px;
            margin-bottom:25px;
          `}
        >
          <InputComponent
            skipSampleProjects
            onX={submitCode}
            ctaText="Scan"
            showValidationBtn={false}
            files={files}
            setFiles={setFiles}
            isLoading={isSubmitLoading}
            compilerVersion={compilerVersion}
            setCompilerVersion={setCompilerVersion}
            mainContract={mainContract}
            compilerSettings={compilerSettings}
            setCompilerSettings={setCompilerSettings}
            setMainFile={setMainFile}
            mainFile={mainFile}
            setMainContract={setMainContract}
            selectedFilePath={selectedFilePath}
            setSelectedFilePath={setSelectedFilePath}
            importPopoverAnchorEl={importPopoverAnchorEl}
            setImportPopoverAnchorEl={setImportPopoverAnchorEl}
          />
        </div>
        <div
          css={`
            margin-bottom: 25px;
            position: relative;
          `}
        >
          {!_.isEmpty(response.errors) && (
            <CompilationErrorsBox compilationErrors={response.errors} />
          )}
          {abi && (
            <>
              <Button
                onClick={handleCopy}
                css={`
                  position: absolute;
                  top: 0;
                  right: 0;
                `}
              >
                {copyTip}
              </Button>
              <div css={`margin-top:20px; padding:10px; border:1px solid #ccc;`}>
                <h3>Generated ABI:</h3>
                <pre>{JSON.stringify(abi, null, 2)}</pre>
              </div>
            </>
          )}
          {isSubmitLoading && <div>Loading...</div>}
        </div>
      </Suspense>
    </div>
  );
}
